module.exports = __webpack_public_path__ + "img/banner.49a72076.svg";